export const PAGE_DETAIL_FETCH = 'PAGE_DETAIL_FETCH';
export const PAGE_DETAIL_SUCCESS = 'PAGE_DETAIL_SUCCESS';
export const PAGE_DETAIL_FAILURE = 'PAGE_DETAIL_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PageDetail/actionTypes.js